export default __webpack_public_path__ + "static/media/video13.a11a99b3.webp";